import Model from "./base/model";
import Client from "../http/client";

class   riskManagerOrder extends Model {
  resourceName() {
    return "risk_manager_orders";
  }

  fields() {
    return {
      order_id:"",
      driver_status: "",
      helper_status:"",
      vehicle_status: "",
      trailer_status:"",
      external_id: "",
      order: {jsonApi: "hasOne", type: "orders"},
      risk_manager: {jsonApi: "hasOne", type: "risk_managers"},
    };
  }
}


export default new riskManagerOrder();
